import React from 'react'
import { FormatDateOptions, useIntl } from 'react-intl'

type AvailabilityProps = {
  ats: number
  inStockDate?: string
  orderable: boolean
  preorderable: boolean
  stockLevel: number
}

const mapStockValues = (
  orderable: boolean,
  stockLevel: number,
  preorderable: boolean
) => {
  const DEFAULT_STOCK_STRING_VALUE = 'out_of_stock'

  if (!orderable) {
    return 'out_of_stock'
  }

  if (preorderable) {
    return 'pre_order'
  }

  if (stockLevel > 0) {
    return 'in_stock'
  }

  return DEFAULT_STOCK_STRING_VALUE
}

const dateFormattingOpts = {
  year: 'numeric',
  day: '2-digit',
  month: '2-digit'
} as FormatDateOptions

const Availability = ({
  inStockDate,
  orderable,
  stockLevel,
  preorderable
}: AvailabilityProps) => {
  const { formatMessage, formatDate } = useIntl()
  const mappedStockValue = mapStockValues(orderable, stockLevel, preorderable)
  const preOrderDate =
    (preorderable &&
      inStockDate &&
      formatDate(new Date(inStockDate), dateFormattingOpts)) ||
    ''

  const stockMessage = {
    in_stock: formatMessage({
      defaultMessage: 'Available immediately',
      id: 'use_product.message.in_stock'
    }),
    out_of_stock: formatMessage({
      defaultMessage: 'Out of stock',
      id: 'use_product.message.out_of_stock'
    }),
    pre_order: formatMessage(
      {
        defaultMessage: 'Ready for dispatch in {preOrderDate}',
        id: 'use_product.message.pre_order'
      },
      {
        preOrderDate: preOrderDate
      }
    )
  }

  return (
    <span
      data-testid='availability'
      className={`availability-msg self-end ${mappedStockValue}`}
    >
      {stockMessage[mappedStockValue]}
    </span>
  )
}

export default Availability
